import { render, staticRenderFns } from "./CustomTransfer.vue?vue&type=template&id=3ba4e532&scoped=true"
import script from "./CustomTransfer.vue?vue&type=script&lang=js"
export * from "./CustomTransfer.vue?vue&type=script&lang=js"
import style0 from "./CustomTransfer.vue?vue&type=style&index=0&id=3ba4e532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4e532",
  null
  
)

export default component.exports